import { useContext } from 'react';
import { NotesRuntimeContext, NotesStateContext } from '@/state/NotesContext';

export function useNotesState() {
  return useContext(NotesStateContext);
}

export function useNotesRuntime() {
  return useContext(NotesRuntimeContext);
}

/**
 * Ordered list of notes for rendering. Sorted by zIndex ascending so later
 * paints go on top.
 */
export function useOrderedNotes() {
  const state = useNotesState();
  return state.order
    .map((id) => state.byId[id])
    .filter((n): n is NonNullable<typeof n> => n !== undefined)
    .sort((a, b) => a.zIndex - b.zIndex);
}
